/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectInput
 */
export interface ProjectInput {
    /**
     * 
     * @type {string}
     * @memberof ProjectInput
     */
    name?: string;
}

/**
 * Check if a given object implements the ProjectInput interface.
 */
export function instanceOfProjectInput(value: object): value is ProjectInput {
    return true;
}

export function ProjectInputFromJSON(json: any): ProjectInput {
    return ProjectInputFromJSONTyped(json, false);
}

export function ProjectInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ProjectInputToJSON(json: any): ProjectInput {
    return ProjectInputToJSONTyped(json, false);
}

export function ProjectInputToJSONTyped(value?: ProjectInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

